import React from "react";
import { Navigate, useParams } from "react-router-dom";
import JalRoLayout from "../components/JalRoLayout";
import {
  ContactCtaSection,
  PageHero,
  ProductDetailSection,
  RelatedLinksSection,
} from "../components/JalRoSections";
import { useProducts } from "../hooks/useSiteData";

const ProductDetailsPage = () => {
  const { slug } = useParams();
  const { items: products, loaded } = useProducts();
  const product = products.find((item) => item.slug === slug);

  if (!product && !loaded) {
    return <JalRoLayout><PageHero title="Loading Product" text="Please wait while product details load." /></JalRoLayout>;
  }

  if (!product) {
    return <Navigate to="/products" replace />;
  }

  return (
    <JalRoLayout>
      <PageHero title={product.title} text={product.text} image={product.image} />
      <ProductDetailSection product={product} />
      <RelatedLinksSection currentSlug={product.slug} type="product" />
      <ContactCtaSection />
    </JalRoLayout>
  );
};

export default ProductDetailsPage;
